import React from "react";
import { Nav } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslation } from "react-i18next";
import { Dropdown } from "react-bootstrap";

const Sidebar: React.FC = () => {
  const { t, i18n } = useTranslation();

  const changeLanguage = (language: string) => {
    i18n.changeLanguage(language);
  };
  return (
    <div
      style={{
        width: "250px",
        height: "100vh",
        position: "fixed",
        top: 0,
        left: 0,
        backgroundColor: "#f8f9fa",
        boxShadow: "2px 0 5px rgba(0, 0, 0, 0.1)",
        padding: "20px 10px",
      }}
      className="d-none d-md-block"
    >
      <div style={{ textAlign: "center", marginBottom: "30px" }}>
        <h2>{t("adminPanel.admin")}</h2>
      </div>
      <Nav className="flex-column">
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            ...styles.navLink,
          }}
        >
          {/* 
           // @ts-ignore */}
          <w3m-button balance="hide" />
        </div>

        <Nav.Link href="/" style={styles.navLink}>
          {t("navbar.ico")}
        </Nav.Link>
        <Nav.Link href="/affiliate" style={styles.navLink}>
          {t("navbar.affiliate")}
        </Nav.Link>
        <Nav.Link href="/revoked-affiliate" style={styles.navLink}>
          {t("navbar.revoked")}
        </Nav.Link>
        <Nav.Link href="/sales" style={styles.navLink}>
          {t("navbar.sales")}
        </Nav.Link>

        <div className="d-flex ms-2 mt-2" style={{ gap: "10px" }}>
          <Dropdown>
            <Dropdown.Toggle variant="info" id="languageDropdown">
              Language
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item key={"en"} onClick={() => changeLanguage("en")}>
                {"English"}
              </Dropdown.Item>
              <Dropdown.Item key={"ko"} onClick={() => changeLanguage("ko")}>
                {"Korean"}
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </Nav>
    </div>
  );
};

const styles = {
  sidebar: {},
  brand: {},
  navLink: {
    fontSize: "18px",
    padding: "10px 15px",
    color: "#333",
    textDecoration: "none",
    cursor: "pointer",
  },
};

export default Sidebar;
